import { useTranslation } from "react-i18next";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import PageHero from "@/components/PageHero";
import SkipToContent from "@/components/SkipToContent";
import ScrollReveal from "@/components/ScrollReveal";

const Privacy = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background text-foreground">
      <SkipToContent />
      <Header />
      <main id="main-content">
        <PageHero
          title={t("privacy.title")}
          subtitle={t("privacy.subtitle")}
        />

        <section className="section-padding">
          <div className="container-wide max-w-4xl mx-auto">
            <ScrollReveal>
              <div className="prose prose-neutral dark:prose-invert max-w-none">
                <h2 className="font-display text-2xl mb-4">{t("privacy.sections.collection.title")}</h2>
                <p className="text-muted-foreground mb-8">
                  {t("privacy.sections.collection.content")}
                </p>

                <h2 className="font-display text-2xl mb-4">{t("privacy.sections.use.title")}</h2>
                <p className="text-muted-foreground mb-8">
                  {t("privacy.sections.use.content")}
                </p>

                <h2 className="font-display text-2xl mb-4">{t("privacy.sections.sharing.title")}</h2>
                <p className="text-muted-foreground mb-8">
                  {t("privacy.sections.sharing.content")}
                </p>

                <h2 className="font-display text-2xl mb-4">{t("privacy.sections.security.title")}</h2>
                <p className="text-muted-foreground mb-8">
                  {t("privacy.sections.security.content")}
                </p>

                <h2 className="font-display text-2xl mb-4">{t("privacy.sections.rights.title")}</h2>
                <p className="text-muted-foreground mb-8">
                  {t("privacy.sections.rights.content")}
                </p>

                <h2 className="font-display text-2xl mb-4">{t("privacy.sections.contact.title")}</h2>
                <p className="text-muted-foreground">
                  {t("privacy.sections.contact.content")}
                </p>
              </div>
            </ScrollReveal>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Privacy;
